import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class CadastroUsuarioBackofficeService {

  constructor(
    private httpService: HttpService
  ) { }
  
  gravarUserbackoffice(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doPost('/backoffice', data, successHandle, errorHandle);

  }
 
}
